import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import QueueAnim from 'rc-queue-anim';
import Title from 'antd/lib/typography/Title';
import { useParams } from 'react-router-dom';

import spinner from '../../../../assets/loading.svg';
import { EmailComponentProps } from '../../../../models/emailComponents';
import EmailComponents from './EmailComponent';
import { Empty, Layout } from 'antd';

const { Content } = Layout;

const EmailComponentsList = (): ReactElement => {
  const { accountId } = useParams<{ accountId: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [components, setComponents] = useState<EmailComponentProps[]>();

  const fetchData = useCallback((): void => {
    axiosConfig('get', `/${accountId}/components/EMAIL`, {}, (response) => {
      const res = response as Record<'data', EmailComponentProps[]>;
      setComponents(res.data);
      setIsLoading(false);
    });
  }, [accountId]);

  useEffect(() => {
    setIsLoading(true);
    fetchData();
  }, [fetchData]);

  if (isLoading || !components) {
    return (
      <div className="spinner">
        <img src={spinner} alt="Loading Spinner" />
      </div>
    );
  }

  if (components.length === 0) {
    return (
      <Content style={{ padding: '24px' }}>
        <Empty
          description="Components are parts of email designs which you wish to reuse multiple times, such as email headers or footers. To create components, simply hover over an element in your email design and click the small save icon which appears."
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </Content>
    );
  }

  return (
    <Content style={{ padding: '24px' }}>
      <Title level={5}>{`Email Template Components:`}</Title>
      <QueueAnim type={['left', 'right']} leaveReverse>
        {/* QueueAnim attaches a ref to its children. This silences an error. */}
        <div>
          {components.map((component) => (
            <EmailComponents
              key={component.componentId}
              component={component}
              fetchTemplates={fetchData}
              changeLoadingState={setIsLoading}
            />
          ))}
        </div>
      </QueueAnim>
    </Content>
  );
};
export default EmailComponentsList;
